import React, { useState } from "react";
import "./ExperiencePower.css";
import ExploreBtn from "../../common/common-btn/explore_btn/ExploreBtn";
import InquiryModal from "../../common/inquiry_modal/InquiryModal";

const ExperiencePower = () => {
  const [showInquiry, setShowInquiry] = useState(false);
  return (
    <section className="ExperiencePower-container">
      <div className="hero-overlay"></div>

      <div className="hero-content">
        <h1 className="hero-title">Experience the Power of Perfect Effects</h1>
        <p className="hero-subtitle">
          Crafted to enhance every detail & elevate your product impact
        </p>

        <ExploreBtn text="Inquire Now" onClick={() => setShowInquiry(true)} />
      </div>
      <InquiryModal
        show={showInquiry}
        handleClose={() => setShowInquiry(false)}
      />
    </section>
  );
};

export default ExperiencePower;
